module.exports = __webpack_public_path__ + "img/parallax_trees_desktop_squeezed.e2424a37.png";